import { storageItemImageReferenceZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-reference";
import { linearGradientZodSchema } from "@@/shared/stylable/background-style";
import { z } from "zod";
import { hexColorZodSchema } from "../stylable/hex-color/hex-color";

// can this even work
type CoverType = "TILE" | "COVER";
const coverZodSchema = z.enum(["TILE", "COVER"]);

// default-branding.ts TODO see if this settings are correct
// backgroundSize: cover === "TILE" ? "auto" : "cover",
// backgroundRepeat: cover === "TILE" ? "repeat" : "no-repeat",

// type BrandingBackground = {
//     textColor: HexColor;
//     color: HexColor;
//     image?: string | StorageItemImageReference | null;
//     gradient?: LinearGradient;

//     cover?: CoverType;
// };

const brandingBackgroundZodSchema = z.object({
    color: hexColorZodSchema,
    textColor: hexColorZodSchema,
    image: storageItemImageReferenceZodSchema.or(z.string()).nullish(),
    gradient: linearGradientZodSchema.nullish(),
    cover: coverZodSchema.optional(),
});

type BrandingBackground = z.infer<typeof brandingBackgroundZodSchema>;

export { brandingBackgroundZodSchema, coverZodSchema };
export type { BrandingBackground, CoverType };
